import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  createLessonsAPIEndpoint,
  EndPoints,
} from "../../../../services/LessonAPI";
import { useSnackbar } from "notistack";
import ConfirmDialog from "../General/ConfirmDialog";

function LessonDetailsDialog({
  openDialog,
  handleCloseDialog,
  selectedLesson,
  onSave,
  centers,
}) {
  const [editMode, setEditMode] = useState(false);
  const [lesson, setLesson] = useState(selectedLesson);
  const { enqueueSnackbar } = useSnackbar();
  const [localLesson, setLocalLesson] = useState(lesson || {});
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const askConfirmation = (action) => {
    setConfirmAction(() => action);
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    if (confirmAction) confirmAction();
    setConfirmOpen(false);
  };

  const handleSave = () => {
    createLessonsAPIEndpoint(EndPoints.editLesson)
      .putById(lesson.id, lesson)
      .then(() => {
        setEditMode(false);
        enqueueSnackbar("Lesson Updated Successfully.", {
          variant: "success",
          style: { fontSize: "16px" },
        });
        if (onSave) onSave();
      })
      .catch((err) => {
        console.error("Failed to save lesson:", err);
        enqueueSnackbar(err.response.data.message || "Lesson Update Failed.", {
          variant: "error",
          style: { fontSize: "16px" },
        });
      });
  };

  const handleUploadVideo = (lessonId, file) => {
    if (!file || !lessonId) return;
    const formData = new FormData();
    formData.append("videoFile", file);

    createLessonsAPIEndpoint(EndPoints.uploadVideo)
      .postById(lessonId, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        setLocalLesson({ ...localLesson, videoUrl: res.data.videoUrl });
        setEditMode(false);
        if (onSave) onSave();
        enqueueSnackbar("Video Uploaded Successfully.", {
          variant: "success",
          style: { fontSize: "16px" },
        });
      })
      .catch((err) => {
        console.error("Failed to upload video:", err);
        enqueueSnackbar(
          err.response.data.message || "Failed to upload video.",
          {
            variant: "error",
            style: { fontSize: "16px" },
          },
        );
      });
  };
  const handleDeleteVideo = (lessonId) => {
    if (!lessonId) return;
    createLessonsAPIEndpoint(EndPoints.deleteVideo)
      .delete(lessonId)
      .then(() => {
        setLocalLesson({ ...localLesson, videoUrl: null });
        setEditMode(false);
        if (onSave) onSave();
        enqueueSnackbar("Video Deleted Successfully.", {
          variant: "success",
          style: { fontSize: "16px" },
        });
      })
      .catch((err) => {
        console.error("Failed to delete video:", err);
        enqueueSnackbar(
          err.response.data.message || "Failed to delete video.",
          {
            variant: "error",
            style: { fontSize: "16px" },
          },
        );
      });
  };

  useEffect(() => {
    if (openDialog && selectedLesson) {
    }
    setLesson(selectedLesson);
    console.log("Selected Lesson:", selectedLesson);
  }, [openDialog, selectedLesson]);

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      className="lesson-dialog"
    >
      {lesson ? (
        <DialogContent className="lesson-dialog-content">
          <DialogTitle className="lesson-dialog-title">
            Lesson Details
          </DialogTitle>
          <DialogContent dividers>
            {lesson ? (
              !editMode ? (
                <Box className="lesson-detail-container">
                  <Grid container spacing={3} justifyContent="space-between">
                    <Grid item size={6}>
                      <Typography>
                        <span className="lesson-detail-label">ID:</span>{" "}
                        <span className="lesson-detail-value">
                          {selectedLesson.id}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={6}>
                      <Typography>
                        <span className="lesson-detail-label">Title:</span>{" "}
                        <span className="lesson-detail-value">
                          {selectedLesson.title}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={12}>
                      <Typography>
                        <span className="lesson-detail-label">
                          Description:
                        </span>{" "}
                        <span className="lesson-detail-value">
                          {selectedLesson.description}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={6}>
                      <Typography>
                        <span className="lesson-detail-label">
                          Center:
                        </span>
                        <span className="lesson-detail-value">
                          {selectedLesson.centerName}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={6}>
                      <Typography>
                        <span className="lesson-detail-label">Free:</span>{" "}
                        <span className="lesson-detail-value">
                          {selectedLesson.isFree ? "Yes" : "No"}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={"auto"}>
                      <Typography>
                        <span className="lesson-detail-label">Max Views:</span>
                        <span className="lesson-detail-value">
                          {selectedLesson.maxViewPerStudent}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={"auto"}>
                      <Typography>
                        <span className="lesson-detail-label">
                          Codes Generated:
                        </span>
                        <span className="lesson-detail-value">
                          {selectedLesson.numOfCodesGenerated || 0}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={"auto"}>
                      <Typography>
                        <span className="lesson-detail-label">Codes Used:</span>
                        <span className="lesson-detail-value">
                          {selectedLesson.numOfCodesUsed || 0}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={6}>
                      <Typography>
                        <span className="lesson-detail-label">Status:</span>{" "}
                        <span className="lesson-detail-value">
                          {selectedLesson.isActive ? "Active" : "Inactive"}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={12}>
                      <Typography>
                        <span className="lesson-detail-label">Created At:</span>{" "}
                        <span className="lesson-detail-value">
                          {new Date(selectedLesson.createdAt).toLocaleString()}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item size={12}>
                      <Typography>
                        <span className="lesson-detail-label">Updated At:</span>{" "}
                        <span className="lesson-detail-value">
                          {new Date(selectedLesson.updatedAt).toLocaleString()}
                        </span>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <>
                  <Box>
                    <TextField
                      fullWidth
                      className="lesson-detail-input"
                      label="Title"
                      margin="normal"
                      value={lesson.title || ""}
                      onChange={(e) =>
                        setLesson({ ...lesson, title: e.target.value })
                      }
                    />
                    <TextField
                      fullWidth
                      className="lesson-detail-input"
                      label="Description"
                      margin="normal"
                      value={lesson.description || ""}
                      onChange={(e) =>
                        setLesson({
                          ...lesson,
                          description: e.target.value,
                        })
                      }
                    />
                    <TextField
                      fullWidth
                      className="lesson-detail-input"
                      label="Max Views"
                      margin="normal"
                      type="number"
                      value={lesson.maxViewPerStudent || ""}
                      onChange={(e) =>
                        setLesson({
                          ...lesson,
                          maxViewPerStudent: Number(e.target.value),
                        })
                      }
                    />
                    <TextField
                      select
                      fullWidth
                      className="lesson-detail-input"
                      label="Center"
                      margin="normal"
                      value={lesson.centerId || ""}
                      onChange={(e) =>
                        setLesson({
                          ...lesson,
                          centerId: Number(e.target.value),
                        })
                      }
                    >
                      {centers.map((center) => (
                        <MenuItem key={center.id} value={center.id}>
                          {center.name}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      select
                      fullWidth
                      className="lesson-detail-input"
                      label="Is Free"
                      margin="normal"
                      value={lesson.isFree !== undefined ? String(lesson.isFree) : ""}
                      onChange={(e) =>
                        setLesson({
                          ...lesson,
                          isFree: e.target.value === "true",
                        })
                      }
                    >
                      <MenuItem value="true">Yes</MenuItem>
                      <MenuItem value="false">No</MenuItem>
                    </TextField>
                    <Box sx={{ mt: 2 }}>
                      {lesson.videoUrl === "" || lesson.videoUrl === null ? (
                        <Button
                          className="btn-upload-video"
                          variant="contained"
                          component="label"
                        >
                          Upload Video
                          <input
                            type="file"
                            accept="video/*"
                            hidden
                            onChange={(e) =>
                              askConfirmation(() =>
                                handleUploadVideo(lesson.id, e.target.files[0]),
                              )
                            }
                          />
                        </Button>
                      ) : (
                        <Button
                          className="btn-delete-video"
                          variant="contained"
                          component="label"
                          color="error"
                          onClick={() =>
                            askConfirmation(() => handleDeleteVideo(lesson.id))
                          }
                        >
                          Delete Video
                        </Button>
                      )}
                    </Box>
                  </Box>
                </>
              )
            ) : (
              <Typography>No data available</Typography>
            )}
          </DialogContent>
          <DialogActions className="lesson-dialog-actions">
            {editMode ? (
              <>
                <Button
                  onClick={() => setEditMode(false)}
                  className="btn-close"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  variant="contained"
                  className="btn-save"
                >
                  Save
                </Button>
              </>
            ) : (
              <>
                <Button onClick={handleCloseDialog} className="btn-close">
                  Close
                </Button>
                <Button
                  onClick={() => setEditMode(true)}
                  variant="contained"
                  className="btn-edit"
                >
                  Edit
                </Button>
              </>
            )}
          </DialogActions>
        </DialogContent>
      ) : null}
      <ConfirmDialog
        open={confirmOpen}
        title="Are you sure?"
        content="This action cannot be undone."
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
      />
    </Dialog>
  );
}

export default LessonDetailsDialog;
